@if(incomeTaxEntity$ | async) {
  <form [formGroup]="partnerPersoonlijkFg" (change)="saveForm()">
    <div class="row col-auto">
      <snelstart-ui-text-form-control class="custom-input-150"
                                      formControlName="voorletters"
                                      id="voorletters"
                                      label="Voorletter(s)"
      >
      </snelstart-ui-text-form-control>
      <snelstart-ui-text-form-control class="custom-input-125"
                                      formControlName="tussenvoegsels"
                                      id="tussenvoegsels"
                                      label="Tussenvoegsel"
      >
      </snelstart-ui-text-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-text-form-control [required]=true
                                      class="custom-input-250"
                                      formControlName="achternaam"
                                      id="achternaam"
                                      label="Achternaam"
      >
      </snelstart-ui-text-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-date-form-control [required]=true
                                      class="custom-input-250"
                                      formControlName="geboortedatum"
                                      id="geboortedatum"
                                      label="Geboortedatum"
                                      placeholder="dd-mm-jjjj"
      >
      </snelstart-ui-date-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-bsn-form-control [required]=true
                                     class="custom-input-250"
                                     formControlName="bsn"
                                     id="bsn"
                                     label="Burgerservicenummer"
      >
      </snelstart-ui-bsn-form-control>
    </div>
    @if ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.biljetSoort === "C") {
      <div class="col-auto">
        <snelstart-ui-select-form-control [options]="optionsLandcodesMetNld"
                                          class="custom-input-250"
                                          formControlName="landCodeNationaliteit"
                                          id="nationaliteit"
                                          label="Nationaliteit"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </form>
  @if ((incomeTaxEntity$ | async)?.aangifte?.biljetSoort === "C") {
    <form [formGroup]="woonlandFg">
      <div class="col-auto">
        <snelstart-ui-select-form-control [options]="optionsLandcodesZonderNld"
                                          class="custom-input-250"
                                          formControlName="landCodeWoonland"
                                          id="landCodeWoonland"
                                          label="Woonland"
        >
        </snelstart-ui-select-form-control>
      </div>
      @if (woonlandFg.get('woonlandVoldoetVoorKwalificatie')?.getRawValue()) {
        <div class="col-auto">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-250"
                                            formControlName="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                            id="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                            label="Kwalificerend belastingplicht"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </form>
  }

  <form [formGroup]="gezamenlijkeAangifteFg">
    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                      [required]=true
                                      class="custom-input-250"
                                      formControlName="gezamenlijkeAangifte"
                                      label="Gezamenlijk aangifte invullen"
    >
    </snelstart-ui-select-form-control>
  </form>

  <!-- indien niet gezamenlijk aangifte -->
<!--  @if ((incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte === false && (incomeTaxEntity$ | async)?.aangifte?.biljetSoort !== 'C') {-->
<!--    <snelstart-venture-fiscaal-feature-iack-info></snelstart-venture-fiscaal-feature-iack-info>-->
<!--  }-->

  @if (!partnerStaatInSnelStartRelatielijst && (incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte) {
    <div class="pt-2" style="width: 75%">
      <snelstart-ui-alert type="warning">
        <b> Belangrijk - Let op!</b> <br/>
        Bij een fiscaal partner is o.a. voor de verzending belangrijk dat deze persoon als <b>afzonderlijke klant</b> is aangemaakt
        in de klantenlijst van SnelStart. Is dat niet het geval? Maak dan nu eerst de partner aan als nieuwe klant, vul het
        burgerservicenummer in (bsn) en geef aan dat
        er sprake is van belastingplicht voor de inkomstenbelasting. Op deze manier kun
        je voor partner de aangifte verzenden, (service)berichten ontvangen, uitstel aanvragen en ook via de partner-klant naar de
        gezamenlijke aangifte toe.
      </snelstart-ui-alert>
    </div>
  }
}
